var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 8.50586C18.7773 8.17188 18.7773 7.61523 18.4434 7.24414L12.209 1.00977C11.6152 0.453125 10.6875 0.861328 10.6875 1.64062V5.20312H5.64062C5.12109 5.20312 4.75 5.61133 4.75 6.09375V9.65625C4.75 10.1758 5.12109 10.5469 5.64062 10.5469H10.6875V14.1094C10.6875 14.9258 11.6523 15.2969 12.209 14.7402L18.4434 8.50586ZM7.125 14.5547V13.0703C7.125 12.8477 6.90234 12.625 6.67969 12.625H3.5625C2.89453 12.625 2.375 12.1055 2.375 11.4375V4.3125C2.375 3.68164 2.89453 3.125 3.5625 3.125H6.67969C6.90234 3.125 7.125 2.93945 7.125 2.67969V1.19531C7.125 0.972656 6.90234 0.75 6.67969 0.75H3.5625C1.5957 0.75 0 2.3457 0 4.3125V11.4375C0 13.4043 1.5957 15 3.5625 15H6.67969C6.90234 15 7.125 14.8145 7.125 14.5547Z",
    fill: "#65646A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.fa665664822ca7ac46345b9abaf157a1.svg";
export { ForwardRef as ReactComponent };